import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PlatformsService} from '../../../../../core/services/platforms.service';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
    selector: 'edit-platform',
    templateUrl: './edit-platform.modal.html',
    styleUrls: ['./edit-platform.modal.scss'],
    standalone: false
})

export class EditPlatformModal {
  public info;
  constructor( public dialogRef: MatDialogRef<EditPlatformModal>,
               @Inject(MAT_DIALOG_DATA) public data: any,
               public platformsService: PlatformsService, private spinner: NgxSpinnerService) {
    this.info = data;
  }

  edit() {
    this.spinner.show();
    for (let i = 0; i < this.info.matrixPlatform.length; i++) {
      let platform = this.info.matrixPlatform[i];
      if (platform?.platform) {
        let obj = {
          organizationId: this.info.id,
          platformId: platform.platform.id,
          enable: platform.enable
        };
        this.platformsService.addMatrixPlatform(obj).subscribe(res => {
          if (i === this.info.matrixPlatform.length - 1) {
            setTimeout(() => {
              this.spinner.hide();
              this.dialogRef.close();
            }, 500);
          }
        });
      }
    }
  }
}
